import { render, staticRenderFns } from "./RemazeContact.vue?vue&type=template&id=2f5a81ca&"
import script from "./RemazeContact.vue?vue&type=script&lang=js&"
export * from "./RemazeContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports